import { ListLink } from '../list/column/ListLink';
import type { processDefinitionQueryFragment$data } from './__generated__/processDefinitionQueryFragment.graphql';

export const ProcessDefinitionListLink = ({
    children,
}: {
    children: Pick<processDefinitionQueryFragment$data, 'definitionName' | 'id'>;
}) => (
    <ListLink params={{ id: children.id }} to="/process-definition/$id">
        {children.definitionName}
    </ListLink>
);
